import React, {Suspense} from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';
import AppLoader from '@crema/components/AppLoader';
const MyAccount = React.lazy(
  () => import('../../../modules/account/MyProfile'),
);

export const accountPagesConfigs = [
  {
    permittedRole: [
      RoutePermittedRole.User,
      RoutePermittedRole.Admin,
      RoutePermittedRole.SupportAgent,
      RoutePermittedRole.teacher,
    ],
    path: '/my-account',
    element: (
      <Suspense fallback={<AppLoader />}>
        <MyAccount />
      </Suspense>
    ),
  },
];
